import React from 'react'
import InfoBranch from './InfoBranch'

import InfoSection from './InfoSection'
import WarrantySection from './WarrantySection'

function ProductForm(): JSX.Element {
  const base = 'f-product-form'

  return (
    <div className={`${base}__con`}>
      <InfoBranch />
      <InfoSection />
      <WarrantySection />
    </div>
  )
}

export default ProductForm
